import { Axios } from "../../../../axios";

export * from "../../base/store/actions";

export function process_field_change(
	{ dispatch, commit, rootGetters },
	payload
) {
	let slug = payload.parent_slug;
	let data = rootGetters[slug + "/answer"];

	data[+payload.item_num - 1][payload.q_slug].answer = payload.answer;
	commit("set_answer", data);
	dispatch("send_multi_answer", slug);
}

export function process_mass_field_change(
	{ dispatch, commit, rootGetters },
	payload
) {
	let slug = payload.parent_slug;
	let i = +payload.item_num - 1;
	let data = rootGetters[slug + "/answer"];
	for (let field in payload.fields) {
		if (payload.fields.hasOwnProperty(field)) {
			data[i][payload.fields[field].q_slug].answer =
				payload.fields[field].answer;
		}
	}

	commit("set_answer", data);
	dispatch("send_multi_answer", slug);
}

export function send_multi_answer(
	{ dispatch, commit, rootGetters },
	question_slug
) {
	Axios.put("/question", {
		app_id: rootGetters.active_application_id,
		q_slug: question_slug,
		value: rootGetters[question_slug + "/answer"]
	})
		.then(function() {
			commit(question_slug + "/set_error_message", "", { root: true });
		})
		.catch(function(error) {
			if (error.response.status === 401) {
				dispatch("logout_user");
			} else if (error.response.status !== 400) {
				commit(
					question_slug + "/set_error_message",
					"Unable to save your response.",
					{ root: true }
				);
			} else {
				let errors = error.response.data.join(", ");
				commit(question_slug + "/set_error_message", errors, { root: true });
			}
		});
}

export function delete_item({ dispatch, commit, rootGetters }, payload) {
	let data = rootGetters[payload.slug + "/answer"];
	data.splice(+payload.item_num - 1, 1);

	commit("set_answer", data);
	dispatch("send_answer", payload.slug);
}

export function add_item({ dispatch, commit, rootGetters }, slug) {
	let data = rootGetters[slug + "/answer"];
	let new_item = JSON.parse(
		JSON.stringify(rootGetters[slug + "/get_empty_item"])
	);
	data.push(new_item);

	commit("set_answer", data);
	dispatch("send_answer", slug);
}

export function get_empty_item(
	{ dispatch, commit, rootGetters },
	question_slug
) {
	Axios.get(
		"/question/empty-item/" +
			question_slug +
			"/" +
			rootGetters.active_application_id
	)
		.then(function(response) {
			commit(question_slug + "/set_empty_item", response.data.answer[0], {
				root: true
			});
		})
		.catch(function(error) {
			if (error.response.status === 401) {
				dispatch("logout_user");
			} else {
				commit(
					question_slug + "/set_error_message",
					"Unable to obtain empty items",
					{ root: true }
				);
			}
		});
}
